export default {
    edit: "Редактиране",
    location: "Местоположение + Условия и правила",
    filter: "Филтър"
}